import {LitElement, css, html} from "lit";
import {mix} from "mixwith";
import StateMixin from "./Mixins/StateMixin.js";
import MutableValueMixin from "./Mixins/MutableValueMixin.js";
import OpenFileDialog from "../OpenFileDialog.js";

export class AuiDropArea extends mix(LitElement).with(StateMixin, MutableValueMixin) {

	static get properties() {
		return {
		};
	}

	constructor() {
		super();
	}

	connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	firstUpdated(changedProperties) {
		super.firstUpdated(changedProperties);
		this.setAttribute("tabindex", 0);
	}

	reset() {
		super.reset();
	}

	openFileDialog() {
		OpenFileDialog().then(files => {
			const event = new CustomEvent("files-added", {
				composed: true,
				detail: {
					files: files
				}
			});

			this.dispatchEvent(event);
		});
	}

	static get styles() {
		return css`
			:host {
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				border: 2px dashed var(--paper-grey-300);
				outline: none;
			}
			
			/* Disabled State */
			:host([disabled]) { opacity: 0.5; }
			
			/* Focus State */
			:host([focused]) {
				border-color: var(--primary-color);
			}
		`;
	}

	render() {
		return html`
			<md-icon>upload_file</md-icon>
			<span>Drag and Drop files here</span>
			<span>Files Supported: PDF, XSLS, Image, Scanner</span>
			<aui-button @click=${() => this.openFileDialog()}>Choose File</aui-button>
			<span>Maximum size: 5MB</span>
		`;
	}

}

export default AuiDropArea;

customElements.define("aui-drop-area", AuiDropArea);